import { render, staticRenderFns } from "./EventSaveButton.vue?vue&type=template&id=cce74e6a&"
import script from "./EventSaveButton.vue?vue&type=script&lang=js&"
export * from "./EventSaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports